export class ImageManipulator {
  image: ImageData;
  /** @constructor */
  constructor(imageData: ImageData) {
    this.image = imageData;
  }

  public get(x: number, y: number) {
    return this.image.data[this.image.width * y + x];
  }

  public put(x: number, y: number, clr: number) {
    this.image.data[this.image.width * y + x] = clr;
  }
}
